
// src/connects/group-members-panel.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import context from '../helpers/context'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import { emitAlertMessage } from '../actions/alert-message'
import { getArray } from '../helpers/store'
import config from '../config'
import map from 'lodash/map'

export const mapStateToProps = (state, ownProps)=> {
  return {
    group: getArray('group_id', state.groups.items, ownProps.group.group_id),
    user: state.user.current,
    isMembershipUpdating: state.groups.isMembershipUpdating,
    isMembershipUpdateFailed: state.groups.isMembershipUpdateFailed,
    access_token: state.sessions.access_token,
    firstLogin: state.user.firstLogin,
    hasMembers: state.account.hasMembers,
    otherMembers: state.accountOtherMembersCount.otherMembers,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> {
      dispatch(actions.fetchOtherMembersCount(props.group.group_id))
      dispatch(actions.fetchAccountOtherMembersCount(props.group.group_id))
      if (!props.productTour || props.productTour.openGroupMemberPanel != 'hide') {
        dispatch(actions.hideProductTour('openGroupMemberPanel'))
      }
    },

    willUpdate: (props, nextProps)=> {
      if (!nextProps.hasMembers) {
        dispatch(actions.fetchAccountOtherMembersCount(nextProps.group.group_id))
      }
    },

    addGroupMembership: (props, users)=> {
      var userNames = map(users, (user)=> {
        dispatch(actions.updateGroupMembership(props.group.group_id, user.user_id, 'member'))
        return user.name
      }).join(', ')
      dispatch(emitAlertMessage({ message: 'label:ユーザを追加しました', name: userNames }, 'success'))
    },

    updateGroupMembership: (props, user, membership)=> {
      if (membership == 'delete')
        dispatch(emitAlertMessage({ message: 'label:グループからユーザを削除しました', name: user.name }, 'success'))
      else if (membership == 'admin')
        dispatch(emitAlertMessage({ message: 'label:グループの管理権限を付与しました', name: user.name }, 'success'))
      else if (membership == 'member')
        dispatch(emitAlertMessage({ message: 'label:グループの管理権限を削除しました', name: user.name }, 'success'))
      dispatch(actions.updateGroupMembership(props.group.group_id, user.user_id, membership))
    },

    updateRemindMailSetting: (props, user, delivery)=> {
      dispatch(actions.updateRemindMailSetting(props.group.group_id, user.user_id, delivery))
      if (delivery)
        dispatch(emitAlertMessage({ message: 'label:ユーザへのリマインドメールの送信を開始します', name: user.name }, 'success'))
      else
        dispatch(emitAlertMessage({ message: 'label:ユーザへのリマインドメールの送信を停止しました', name: user.name }, 'success'))
    },

    sortGroupMembers: (props, sort) => {
      dispatch(actions.sortGroupMembers(props.group.group_id, sort))
    },

    startSorting: ()=> {
      dispatch(emitAlertMessage('label:ドラッグして並べ替え', 'success'))
    },
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    usersAdminUrl: `${config.baseUrl}v3/session/redirect?login=true&redirect_to=/v3/users/new?group_id=${ownProps.group.group_id}&access_token=${stateProps.access_token}`,
    usersAccountUrl: `${config.baseUrl}v3/session/redirect?login=true&redirect_to=/v3/users&access_token=${stateProps.access_token}`,
  })
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: {
    active: false,
  }}),
  context({ showUserSelectionDialog: PropTypes.func }),
  lifecycle,
  translate(),
  trackPage('group_members'),
)



// WEBPACK FOOTER //
// ./src/connects/group-members-panel.js